/**
 * Why does this perversion even exist... ?
 * Don't judge me please, I tried to avoid having to code this thing...
 * Unfortunately here we are 🤷‍♂️
 * Courtesy of: the usual suspects.
 */
import PropTypes from 'prop-types';

// Internal =====================================
const Component = React.Component;

// CustomDropdown Component ===========================
export default class CustomDropdown extends Component {
  static propTypes = {
    wrapperClassName: PropTypes.string,
    textClassName: PropTypes.string,
    inputName: PropTypes.string,
    isRequired: PropTypes.bool,
    externalChangeHandler: PropTypes.func,
    placeHolderText: PropTypes.string
  };

  static defaultProps = {
    wrapperClassName: '',
    textClassName: '',
    inputName: '',
    inputId: '',
    isRequired: false,
    placeHolderText: '',
    externalChangeHandler: () => {}
  };

  constructor(props, context) {

    super(props, context);

    const { children: text, value } = Array.isArray(this.props.children.props.children)
      ? this.props.children.props.children[0].props
      : this.props.children.props.children.props;

    this.state = {
      text, value, optionIndex: 0
    };
  }

  componentDidMount() {

    const elem = Array.from(this.props.children).find(el => el.props.value === this.props.val);

    if (elem) {
      this.setState({
        text: elem.props.children,
        value: elem.props.value
      });
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.val) {

      const elem = Array.from(this.props.children).find(el => el.props.value === nextProps.val);

      if (elem) {
        this.setState({
          text: elem.props.children,
          value: elem.props.value
        });
      }
    }
  }

  preventIOSFocus = (e) => {

    e.preventDefault();
  }

  getIndexOf = (element) => Array.from(element.parentNode.children).indexOf(element);

  changeHandler = (e) => {

    const optionsArray = Array.from(e.target.children);
    const selectedOption = optionsArray.find(el => el.selected);
    const optionIndex = this.getIndexOf(selectedOption);
    const { text, value } = selectedOption;

    this.setState({ text, value, optionIndex }, this.props.externalChangeHandler(e));
  }

  renderOptions = () => {

    const { props } = this;
    const { inputName, children } = props;
    let opts = [];

    if (Array.isArray(children)) {

      opts = children.map((option, index) => (<option key={ `${inputName}-${index}` } value={ option.props.value }>{ option.props.children }</option>));
    } else {

      opts = [(<option key={ `${inputName}-0` } value={ children.props.value }>{ children.props.children }</option>)];
    }

    return opts;
  }

  render() {

    const { props, state, changeHandler, preventIOSFocus } = this;
    const { wrapperClassName, textClassName, inputId, inputName, isRequired, placeHolderText } = props;
    const { text, value, optionIndex } = state;
    const dangerousHtml = (placeHolderText.length && optionIndex === 0) ? placeHolderText : text;

    return (
      <div className={`${wrapperClassName}`}>
        <div className={`ddl-text react-custom-ddl ${(placeHolderText.length && optionIndex === 0) ? '' : 'no-placeholder' } ${textClassName}`} dangerouslySetInnerHTML={{ __html: dangerousHtml }}/>
        <select
          id={ inputId }
          name={ inputName }
          required={ isRequired }
          onChange={ changeHandler }
          onFocus={ preventIOSFocus }
          onBlur={ preventIOSFocus }
          value={ value } >
          { this.props.children }
        </select>
      </div>
    );
  }
}
